import { matchPath, type RouteObject } from 'react-router-dom';

import type { UrlEntry } from '@app/urls';

/**
 * Scans the application's RouteObject configuration tree
 * to look up a specific route matching the provided template path string.
 */
export function findRouteByPathTemplate(path: string, items: RouteObject[]): RouteObject | null {
  for (const item of items) {
    if (item.path === path) {
      return item;
    }

    if (item.children) {
      const found = findRouteByPathTemplate(path, item.children);
      if (found) {
        return found;
      }
    }
  }

  return null;
}

export function buildBreadcrumbs(urls: Record<string, UrlEntry>, pathname: string): UrlEntry[] {
  const urlValues = Object.values(urls);
  const pathMap = new Map(urlValues.map((url) => [url.path, url]));

  let route: UrlEntry | undefined;
  for (const url of urlValues) {
    const match = matchPath({ path: url.path, end: true }, pathname);
    if (match) {
      if (!route || url.path.length > route.path.length) {
        route = url;
      }
    }
  }

  const crumbs: UrlEntry[] = [];
  while (route) {
    crumbs.unshift(route);
    route = route.parent ? pathMap.get(route.parent) : undefined;
  }

  return crumbs;
}
